import { app_generic_resources_hdr_RowClass, app_generic_resources_hdr_RowInterface } from '../../dbschema';
import {BaseContainerModel} from '../base-container.model';

export class AppGenericResourcesHdrContainerModel extends BaseContainerModel {
  app_generic_resources_hdr: app_generic_resources_hdr_RowInterface = new app_generic_resources_hdr_RowClass();
}

